import React, { useEffect, useState } from 'react';
import { useLocation } from '@reach/router';
import styled from 'styled-components';
import FooterDetails from '@components/footer/FooterDetails';
import FooterFDA from '@components/footer/FooterFDA';
import FooterLinks from '@components/footer/FooterLinks';
import FooterRegister from '@components/footer/FooterRegister';
import Colors from '@components/shared/Colors';
import SocialIcons from '@components/shared/SocialIcons';
import useDesktop from '@components/shared/useDesktop';
import { pageIsAccountPage } from '@utils/helpers';

const Footer: React.FC = () => {
  const desktop = useDesktop(1024);
  const location = useLocation();
  const [footerColor, setFooterColor] = useState(Colors.forestGreen);

  useEffect(() => {
    if (pageIsAccountPage(location.pathname)) {
      setFooterColor(Colors.navyBlue);
    }
  }, []);

  if (desktop) {
    return (
      <>
        <Container color={footerColor}>
          <Inner>
            <FooterDetails />
            <FooterLinks social={true} />
            <FooterRegister />
          </Inner>
        </Container>
        <FooterFDA />
      </>
    );
  }

  return (
    <>
      <Container color={footerColor}>
        <Inner>
          <SocialIcons size={26} color={Colors.paleGold} />
          <div style={{ height: 30 }} />
          <FooterRegister />
          <FooterLinks social={false} />
          <FooterDetails />
        </Inner>
      </Container>
      <FooterFDA />
    </>
  );
};

export default Footer;

interface StyleProps {
  color: string;
}

const Container = styled.div<StyleProps>`
  padding: 50px 30px;
  position: relative;
  background-color: ${(props) => props.color};

  @media (max-width: 1024px) {
    padding: 30px;
  }
`;

const Inner = styled.div`
  max-width: 1200px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 0 auto;
  gap: 40px;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    gap: 0;
  }
`;
